module.exports = __webpack_public_path__ + "img/horizontal_4_2_9006.782670dc.png";